import { TypeFilesEnum } from '~/src/models/enums/type-files.enum';
import { getDataProducts } from '~/src/layouts/clients-request-layout/clients-request-layout.utils';
import { checkUndefinedString, getEmail, getLegalName, getPhone } from './get-mapping-form-data.helper';
import type { CreateLeadBaseInterface } from '~/src/repositories/lead/types/lead.types';
import type { MappingDataOverridesInterface } from '~/src/models/types/mapped-data-form.types';

interface CreateLeadInterface {
    requestBody: CreateLeadBaseInterface;
    formDataFromEntries: {
        [k: string]: FormDataEntryValue;
    };
}

export function getMappingData(props: MappingDataOverridesInterface): CreateLeadInterface {
    const {
        formData,
        getFilesData,
        regionsData,
        opf,
        mtsProductCodesOutOfForm,
        innOutOfForm,
        ogrnOutOfForm,
        clientType,
    } = props;

    const formDataFromEntries = Object.fromEntries(formData);
    const firstElem = 0;

    const { contactFio, phoneNumber, legalName, inn, ogrn, serviceProvisionAddress, comment, email } =
        formDataFromEntries;

    const [regionData] = regionsData.filter((elem) => elem.name === formDataFromEntries['regionId']);

    const emailForReturnedData = getEmail(checkUndefinedString(String(email)));

    const requestBody = {
        inn: innOutOfForm || checkUndefinedString(String(inn)),
        ogrn: ogrnOutOfForm || checkUndefinedString(String(ogrn)),
        legalName: checkUndefinedString(getLegalName(legalName, opf?.shortName)),
        clientType,
        contactFio: checkUndefinedString(String(contactFio)),
        phoneNumber: getPhone(String(phoneNumber)),
        ...(emailForReturnedData ? { email: emailForReturnedData } : {}),
        regionId: regionData.id,
        mtsProductCodes: mtsProductCodesOutOfForm?.length ? mtsProductCodesOutOfForm : getDataProducts(formData),
        serviceProvisionAddress: checkUndefinedString(String(serviceProvisionAddress)),
        comment: checkUndefinedString(String(comment)),
        file: getFilesData ? getFilesData(TypeFilesEnum.additionLead)[firstElem] : undefined,
    };

    return { formDataFromEntries, requestBody };
}
